import { initGraphQLTada, ResultOf } from 'gql.tada';
import type { introspection } from './graphql-env.js';
import { GQLScalarTypes } from '@/helpers/gql-scalar-types.js';

export const gql = initGraphQLTada<{
  introspection: introspection;
  disableMasking: true;
  scalars: GQLScalarTypes;
}>();

export const userPermsFragment = gql(`
  fragment UserPermsFragment on UserPerms {
    assemblies
    assignments
    backflowTests
    backflowTesters
    billing
    credentials
    customers
    gauges
    jobs
    notices
    profiles
    addresses
    recycledWaterInspections
    tags
    vendors
    users
    waterSites
    waterSuppliers
    waterServices
    hazardSurveys
  }
`);

export type PermKey = keyof ResultOf<typeof userPermsFragment>;
export type Perm = ResultOf<typeof userPermsFragment>['assemblies'][number];
export type UserPerms = { [K in PermKey]: Perm[] };
